import axios from "axios";
// Entities
import { Preparation, PreparationsFields } from "@/entities/index";

export async function getPreparations({
  client,
  userId,
  preparationsFields,
}: {
  client: string;
  userId: number;
  preparationsFields: PreparationsFields;
}): Promise<Preparation[]> {
  const preparations = (
    await axios.post(`/api/orders`, {
      client,
      reference: preparationsFields.reference,
      recipientReference: preparationsFields.recipientReference,
      clientNumber: preparationsFields.clientNumber,
      status: preparationsFields.status,
      warehouse: preparationsFields.warehouse,
      shippingDateBegin: preparationsFields.shippingDateBegin,
      shippingDateEnd: preparationsFields.shippingDateEnd,
      receptionDateBegin: preparationsFields.receptionDateBegin,
      receptionDateEnd: preparationsFields.receptionDateEnd,
    })
  ).data as Preparation[];
  preparations.forEach((preparation) => {
    if (preparation.warehouse === "CHA") {
      preparation.warehouse = "Chalon";
    } else if (preparation.warehouse === "SAV") {
      preparation.warehouse = "TL89";
    }
  });
  await axios.post("/api/stats/action", {
    userId,
    action: "Recherche des préparations de commandes",
  });

  return preparations;
}
